export const PLANS = [
  {
    id: "monthly",
    name: "Monthly Renew",
    price: 34.99,
    foundingPrice: 29.99,
    unit: "/ visit",
    cadence: "Billed every 4 weeks",
    minimum: "3-cleaning minimum",
    extra: 10,
    popular: true,
    blurb: "Our most popular plan — bins stay fresh year-round on autopilot.",
    features: [
      "Includes 2 bins every visit",
      "Automatic cleaning every 4 weeks",
      "Fresh, deodorized & sanitized bins",
      "Founding Customer Special: first 3 visits $29.99",
      "Pause or cancel after 3 visits",
    ],
  },
  {
    id: "quarterly",
    name: "Quarterly Renew",
    price: 44.99,
    unit: "/ visit",
    cadence: "Billed every 12 weeks",
    minimum: "2-cleaning minimum",
    extra: 10,
    popular: false,
    blurb: "Seasonal deep cleans to keep odor and grime under control.",
    features: [
      "Includes 2 bins every visit",
      "Deep clean every 12 weeks",
      "High-pressure hot-water blast",
      "Eco-friendly, biodegradable soap",
      "Pause or cancel after 2 visits",
    ],
  },
  {
    id: "onetime",
    name: "One-Time Deep Clean",
    price: 59.99,
    unit: "",
    cadence: "No commitment",
    minimum: "Single visit",
    extra: 15,
    popular: false,
    blurb: "Try us once — no subscription, no strings attached.",
    features: [
      "Includes 2 bins in one visit",
      "One thorough deep clean",
      "Perfect for move-ins or one-offs",
      "No recurring charges",
      "Book anytime",
    ],
  },
];

export const planById = (id) => PLANS.find((p) => p.id === id);
